import { resolve } from "path";

export default [
  "$stateProvider",
  "$urlRouterProvider",
  function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("knowYourCustomer", {
      parent: "loginModule",
      url: "/kyc",

      templateProvider: [
        "$q",
        ($q) => {
          return $q((resolve) => {
            require.ensure([], () =>
              resolve(
                require("./eaKnowYourCustomerPage/eaKnowYourCustomerPageModule.html")
              )
            );
          });
        },
      ],
      controller: "eaKnowYourCustomerPageModuleController",
      controllerAs: "$ctrl",
      resolve: {
        ctrl: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            return $q((resolve) => {
              require.ensure([], () => {
                let module = require("./index.js");
                $ocLazyLoad.load({ name: module.default });
                resolve();
              });
            });
          },
        ],
      },
    });
    $stateProvider.state("knowYourCustomerCompleted", {
      parent: "loginModule",
      url: "/kycConfirmed",
      templateProvider: [
        "$q",
        ($q) => {
          return $q((resolve) => require.ensure([], () => resolve(require("./eaKnowYourCustomerCompletedPage/eaKnowYourCustomerCompletedPageModule.html"))));
        },
      ],
      controller: "eaKnowYourCustomerCompletedPageModuleController",
      controllerAs: "$ctrl",
      resolve: {
        ctrl: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            return $q((resolve) => {
              require.ensure([], () => {
                let module = require("./index.js");
                $ocLazyLoad.load({ name: module.default });
                resolve();
              });
            });
          },
        ],
      },
    });
  },
];



// WEBPACK FOOTER //
// ./src/ui/modules/eaLoginMain/eaKnowYourCustomer/routes.js